<template>
    <div class="toggle-group">
        <div class="form-check d-flex align-items-center">
            <div
                class="toggle-container"
                :class="{
                    active: localValue,
                    disabled: disabled,
                    hoverable: !readonly,
                }"
                tabindex="0"
                @click="toggle"
                @keydown.enter="toggle"
            >
                <div class="toggle-button"></div>
            </div>
            <span v-if="text" class="form-check-label" @click="toggle">
                {{ text }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ToggleField',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
    },
    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('change', value);
            },
        },
    },
    methods: {
        toggle() {
            if (this.disabled || this.readonly) {
                return;
            }
            // Toggle the value, this automatically triggers the setter on localValue
            this.localValue = !this.localValue;
        },
    },
};
</script>

<style scoped>
.toggle-container {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1.5px solid var(--neutral-800);
    border-radius: 1.3125rem;
    transition: background-color 0.3s ease-in-out;
    width: var(--size-9);
    height: var(--size-5);
    position: relative;
    box-sizing: border-box;
}

.toggle-button {
    background-color: var(--neutral-700);
    border-radius: 1.3125rem;
    transform: translateX(0);
    transition: transform 0.3s ease-in-out;
    width: 0.875rem;
    height: 0.875rem;
    position: absolute;
    left: 0.2rem;
    top: 0.15rem;
}

.toggle-container.active .toggle-button {
    background-color: var(--success);
    transform: translateX(0.88rem);
}

.disabled {
    opacity: 0.5;
}
</style>
